import styled from 'styled-components'

import { BREAKPOINTS, COLOURS } from 'resources'
import { ReactComponent as ReklaimWordmark } from 'resources/images/brand/reklaim-wordmark.svg'

const ANIMATION_HIDE_MS = 400
const ANIMATION_SHOW_MS = 200
export const NavMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  visibility: hidden;
  opacity: 0; /* To prevent ghosting on nav menu close transition */
  width: 0;
  flex: 1;
  min-height: 0;

  position: fixed;
  transform: translate(0, -100%);
  @media (min-width: ${BREAKPOINTS.md}) {
    transform: translate(-100%, 0);
    &.visible {
      position: initial;
    }
  }

  transition-property: transform, width, position, visibility, opacity;
  transition-timing-function: ease-in;
  transition-duration: ${ANIMATION_HIDE_MS}ms, 0s, 0s, 0s, 0s;
  transition-delay: 0s, ${ANIMATION_HIDE_MS}ms, ${ANIMATION_HIDE_MS}ms, ${ANIMATION_HIDE_MS}ms, ${ANIMATION_HIDE_MS}ms;

  &.visible {
    width: 100%;
    visibility: visible;
    opacity: 1;
    transform: translate(0, 0);

    transition-property: transform;
    transition-timing-function: ease-out;
    transition-duration: ${ANIMATION_SHOW_MS}ms;
    transition-delay: 0s;
  }
`

// Desktop Nav Menu
export const DesktopNavMenu = styled.div`
  background-color: ${COLOURS.neutralGrey1};
  display: none;
  height: 100%;
  width: 250px;

  @media (min-width: ${BREAKPOINTS.md}) {
    display: block;
  }
`

export const DesktopNavMenuContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100vh;
  height: 100%;
  position: sticky;
  top: 0;
  flex: 1;
`

// Mobile Nav Bar
export const MobileNavBarSpacer = styled.div`
  height: 60px;
  width: 100%;
  display: none;

  &.visible {
    display: block;
  }

  @media (min-width: ${BREAKPOINTS.md}) {
    &.visible {
      display: none;
    }
  }
`

export const MobileNavBar = styled.div`
  height: 60px;
  width: 100%;
  background-color: ${COLOURS.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;

  @media (min-width: ${BREAKPOINTS.md}) {
    display: none;
  }
`

export const MobileNavBarHamburgerButton = styled.button`
  border: none;
  background: none;
  padding: 10px;
`

export const MobileNavBarHamburgerIcon = styled.img`
  width: 30px;
  height: 30px;
`

export const MobileNavBarReklaimLogoContainer = styled.div`
  max-width: 110px;
`

export const MobileNavBarReklaimLogo = styled(ReklaimWordmark)`
  width: 100%;
  height: auto;

  path {
    fill: ${COLOURS.neutralBlack};
  }
`

export const MobileNavBarPointsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 3px 10px;
  background: ${COLOURS.secondaryPurple2};
  border-radius: 4px;
  margin: 0 10px;
`

export const MobileNavBarPoints = styled.div`
  color: ${COLOURS.secondaryPurple1};
  font-weight: bold;
`

// Mobile Nav Menu
export const MobileNavMenuBackground = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  transition: all 0.3s;
`

export const MobileNavMenuContentContainer = styled.div`
  width: 90%;
  max-width: 250px;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${COLOURS.neutralGrey1};
  transition: all 0.3s;
`

export const MobileNavMenu = styled.div`
  position: fixed;
  top: 0;
  visibility: hidden;
  transition: visibility 0.3s ease-out 0.3s;

  @media (min-width: ${BREAKPOINTS.md}) {
    display: none;
  }

  ${MobileNavMenuBackground} {
    background-color: transparent;
  }

  ${MobileNavMenuContentContainer} {
    margin-left: -250px;
  }

  &.is-open {
    visibility: visible;
    transition: none;
    ${MobileNavMenuBackground} {
      background-color: rgba(0, 0, 0, 0.4);
    }

    ${MobileNavMenuContentContainer} {
      margin-left: 0;
    }
  }
`

// Nav Menu Headers - Desktop
export const NAV_MENU_HEADER_HEIGHT = 140
export const NavMenuHeaderDesktopContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 30px 30px 20px;
  height: ${NAV_MENU_HEADER_HEIGHT}px;
`

// Nav Menu Headers - Mobile
export const NavMenuHeaderMobileContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 10px 20px 30px;
  height: ${NAV_MENU_HEADER_HEIGHT}px;
`

export const NavMenuHeaderMobileCloseButton = styled.button`
  align-self: flex-start;
  border: none;
  background: none;

  &:hover {
    text-decoration: none;
    color: ${COLOURS.black};
    opacity: 0.7;
  }
`

export const NavMenuHeaderMobileCloseButtonIcon = styled.img`
  width: 30px;
  height: 30px;
`
